import classNames from "clsx";
import { HTMLAttributes } from "react";

import { GalleryBlock, ImageBlock, TextBlock } from "@shared/components";
import { TContentBlock } from "@shared/types";

type Props = {
  contentBlocks: TContentBlock[];
  containerClasses?: string;
} & HTMLAttributes<HTMLDivElement>;

export default function ContentBlocks({
  contentBlocks,
  containerClasses,
  ...props
}: Props) {
  return (
    <div
      className={classNames(
        "flex flex-col items-center gap-y-8 lg:gap-y-14",
        containerClasses,
      )}
      {...props}
    >
      {contentBlocks?.map((item: TContentBlock, index: number) => {
        if (item.type === "text")
          return (
            <TextBlock
              content={item.content}
              key={`${item.type}${index}`}
              containerClasses="md:w-[700px] max-w-screen-md mx-4"
            />
          );
        if (item.type === "image")
          return (
            <ImageBlock
              w={900}
              h={900}
              rt="fit"
              src={item.content.src}
              caption={item.content.caption}
              description={item.content.description}
              key={`${item.type}${index}`}
              containerClasses="justify-between"
              className="max-h-[90vh] lg:max-h-[80vh] w-auto object-contain"
            />
          );
        if (item.type === "gallery")
          return (
            <GalleryBlock
              title={item.content.title}
              description={item.content.description}
              files={item.content.files}
              key={`${item.type}${index}`}
            />
          );
        return null;
      })}
    </div>
  );
}
